export default __webpack_public_path__ + "static/media/1.96797814.png";